<form role="form" class="form-inline rech-form">
	<div class="form-group">
		<label for="nom">Nom&nbsp;:&nbsp;</label>
		<input type="text" id="nom" name="nom" class="form-control" placeholder="Nom" [(ngModel)]="filters.nom" (ngModelChange)="applyFilters()">
	</div>

	<div class="form-group">
		<label for="prenom">Pr&eacute;nom&nbsp;:&nbsp;</label>
		<input type="text" id="prenom" name="prenom" class="form-control" placeholder="Pr&eacute;nom" [(ngModel)]="filters.prenom" (ngModelChange)="applyFilters()">
	</div>

	<div class="form-group">
		<label for="nomEntreprise">Entreprise&nbsp;:&nbsp;</label>
		<input type="text" id="nomEntreprise" name="nomEntreprise" class="form-control" placeholder="Entreprise" [(ngModel)]="filters.nomEntreprise" (ngModelChange)="applyFilters()">
	</div>

	<div class="form-group">
		<label for="nomEntreprise">Interne:&nbsp;</label>
		Oui
		<input type="radio" class="form-control rdbChoixOuiNon" name="interne" id="interne_oui" [value]="true" [(ngModel)]="filters.interne" (ngModelChange)="applyFilters()">
		Non
		<input type="radio" class="form-control rdbChoixOuiNon" name="interne" id="interne_non" [value]="false" [(ngModel)]="filters.interne" (ngModelChange)="applyFilters()">
		Tous
		<input type="radio" class="form-control rdbChoixOuiNon" name="interne" id="interne_tous" [value]="null" [(ngModel)]="filters.interne" (ngModelChange)="applyFilters()">
	</div>
	
	<div class="form-group">
		<label for="nomEntreprise">Travailleur d&eacute;tach&eacute;:&nbsp;</label>
		Oui
		<input type="radio" class="form-control rdbChoixOuiNon" name="travailleurDetache" id="travailleur_oui" [value]="true" [(ngModel)]="filters.travailleurDetache" (ngModelChange)="applyFilters()">
		Non
		<input type="radio" class="form-control rdbChoixOuiNon" name="travailleurDetache" id="travailleur_non" [value]="false" [(ngModel)]="filters.travailleurDetache" (ngModelChange)="applyFilters()">
		Tous
		<input type="radio" class="form-control rdbChoixOuiNon" name="travailleurDetache" id="travailleur_tous" [value]="null" [(ngModel)]="filters.travailleurDetache" (ngModelChange)="applyFilters()">
	</div>
	
	<div class="form-group">
		<label for="nomEntreprise">Actif&nbsp;:&nbsp;</label>
		Oui
		<input type="radio" class="form-control rdbChoixOuiNon" name="statut" id="statut_oui" [value]="true" [(ngModel)]="filters.statut" (ngModelChange)="applyFilters()">
		Non
		<input type="radio" class="form-control rdbChoixOuiNon" name="statut" id="statut_non" [value]="false" [(ngModel)]="filters.statut" (ngModelChange)="applyFilters()">
		Tous
		<input type="radio" class="form-control rdbChoixOuiNon" name="statut" id="statut_tous" [value]="null" [(ngModel)]="filters.statut" (ngModelChange)="applyFilters()">
	</div>
								
	<button type="button" class="btn btn-primary" (click)="resetFilters()">R&eacute;initialiser</button>
</form>